import { breakpointValues, Button, PartialOutageError, useResponsiveBreakpoint } from '@atlassian/mpac-primitives';
import UFOLoadHold from '@atlassian/ufo-load-hold';
import React from 'react';
import { AppTileGridSkeleton, AppTilesGridContainer } from '../../primitives';
import { ButtonContainer, ErrorContainer, GridFooterContainer, InitialFetchErrorContainer } from './PaginatedAppGrid.styles';
// TODO: Replace with actual error UI
const InitialFetchError = () => /*#__PURE__*/React.createElement(InitialFetchErrorContainer, null, /*#__PURE__*/React.createElement(PartialOutageError, null));
const FetchMoreError = () => /*#__PURE__*/React.createElement(ErrorContainer, null, /*#__PURE__*/React.createElement(PartialOutageError, {
  level: "tile"
}));
export const PaginatedAppGrid = _ref => {
  let {
    renderGrid,
    isLoading,
    isLoadingMore,
    onLoadMoreClick,
    showLoadMoreButton,
    fetchMoreError,
    initialFetchError,
    desktopColumns = 3,
    tabletColumns = 2,
    mobileColumns = 1
  } = _ref;
  const {
    value: breakpoint
  } = useResponsiveBreakpoint();
  const loadingMoreTileCount = breakpoint < breakpointValues.md ? tabletColumns : desktopColumns;
  if (initialFetchError) {
    return /*#__PURE__*/React.createElement(InitialFetchError, null);
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AppTilesGridContainer, {
    desktopColumns: desktopColumns,
    tabletColumns: tabletColumns,
    mobileColumns: mobileColumns
  }, isLoading ? /*#__PURE__*/React.createElement(UFOLoadHold, {
    name: "app-tile"
  }, /*#__PURE__*/React.createElement(AppTileGridSkeleton, {
    tileCount: desktopColumns * 2
  })) : renderGrid(), isLoadingMore && /*#__PURE__*/React.createElement(AppTileGridSkeleton, {
    tileCount: loadingMoreTileCount
  })), /*#__PURE__*/React.createElement(GridFooterContainer, null, fetchMoreError && /*#__PURE__*/React.createElement(FetchMoreError, null), showLoadMoreButton && /*#__PURE__*/React.createElement(ButtonContainer, null, /*#__PURE__*/React.createElement(Button, {
    isLoading: isLoadingMore,
    onClick: onLoadMoreClick,
    "aria-label": "Load more apps"
  }, "Load more"))));
};